import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface CtaConfig {
  label: string;
  to?: string;
  href?: string;
  newTab?: boolean;
  icon?: React.ReactNode;
  onClick?: () => void;
}
interface PageHeaderProps {
  eyebrow: string;
  eyebrowClass?: string;
  title: string;
  subtitle: string;
  primaryCta?: CtaConfig;
  secondaryCta?: CtaConfig;
}
export const PageHeader = ({
  eyebrow,
  eyebrowClass = 'bg-zano-blush text-zano-pink border border-zano-pink/30',
  title,
  subtitle,
  primaryCta,
  secondaryCta
}: PageHeaderProps) => {
  return <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-20 overflow-hidden" data-id="element-1561" data-mp="2zghkpu2yctf4">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[420px] bg-zano-lavender/40 rounded-full blur-3xl -z-10" data-id="element-1562" data-mp="2brf66v3m7gou" />
      <div className="absolute top-24 right-0 w-[420px] h-[420px] bg-zano-blush/50 rounded-full blur-3xl -z-10" data-id="element-1563" data-mp="27osbmmfk7hny" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1564" data-mp="3gq7n1pryjuno">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-1565" data-mp="3lpaf89mua6e8">
          <Badge className={`mb-6 ${eyebrowClass}`} data-id="element-1566" data-mp="3vhyb925zw6bw">{eyebrow}</Badge>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-zano-charcoal mb-6 leading-[1.1]" data-id="element-1567" data-mp="2xtes7p356lr8">
            {title}
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-1568" data-mp="37qkkh0nhsit1">
            {subtitle}
          </p>
          {(primaryCta || secondaryCta) && <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1569" data-mp="3cn171qf1mp40">
              {/* Secondary on the left */}
              {secondaryCta && (secondaryCta.href ? <a href={secondaryCta.href} target={secondaryCta.newTab ? '_blank' : undefined} rel={secondaryCta.newTab ? 'noopener noreferrer' : undefined} className="w-full sm:w-auto" data-id="element-1570" data-mp="2o2b5c9kjpfqh">
                    <Button variant="secondary" className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1571" data-mp="2t2foy8gr2qkx">
                      {secondaryCta.icon}
                      {secondaryCta.label}
                    </Button>
                  </a> : secondaryCta.to ? <Link to={secondaryCta.to} className="w-full sm:w-auto" data-id="element-1572" data-mp="2e684r85cdp5n">
                    <Button variant="secondary" className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1573" data-mp="29clsvi705paw">
                      {secondaryCta.icon}
                      {secondaryCta.label}
                    </Button>
                  </Link> : <Button variant="secondary" onClick={secondaryCta.onClick} className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1574" data-mp="17g7obhimhd11">
                    {secondaryCta.icon}
                    {secondaryCta.label}
                  </Button>)}
              {/* Primary on the right */}
              {primaryCta && (primaryCta.to ? <Link to={primaryCta.to} className="w-full sm:w-auto" data-id="element-1575" data-mp="1v8em8l3zxs2k">
                    <Button variant="primary" className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1576" data-mp="1gama82xnrlt4">
                      {primaryCta.label}{' '}
                      <ArrowRight size={18} className="ml-1.5" data-id="element-1577" data-mp="4vp6ro0q8u28" />
                    </Button>
                  </Link> : <Button variant="primary" onClick={primaryCta.onClick} className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1578" data-mp="9vbkrzodqec3">
                    {primaryCta.label}{' '}
                    <ArrowRight size={18} className="ml-1.5" data-id="element-1579" data-mp="gbv9tvucvgbw" />
                  </Button>)}
            </div>}
        </motion.div>
      </div>
    </section>;
};